export enum ChatScope {
  Workspace = 'Workspace',
  Space = 'Space'
}
